import React, { useState } from 'react';
import { Box, Modal, IconButton } from '@mui/material';
import { DataGrid, esES } from '@mui/x-data-grid';
import { getTicketsDet } from 'src/app/api/reportes-tickets';
import { SweetAlertBasic } from 'src/app/sweetAlert';
import CloseIcon from '@mui/icons-material/Close';
import TicketModal from '../../mesa_servicio_reportes/reportes/result_search/modal';

const modalStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  // width: 400,
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
  height: '60%',
  width: '90%',
};

const TicketsModal = ({ openModal, handleCloseModal, loading, ticketsData }) => {
  const columns = [
    {
      field: 'oficina',
      headerName: 'Oficina',
      flex: 1,
      align: 'center',
    },
    {
      field: 'numreportesoc',
      headerName: '# Reporte SOC',
      flex: 1,
    },
    {
      field: 'numreportebestel',
      headerName: '# Reporte Bestel',
      flex: 1,
    },
    {
      field: 'responsable',
      headerName: 'Responsable',
      flex: 1,
    },
    {
      field: 'fcInicioTicket',
      headerName: 'Fecha Inicio Ticket',
      flex: 1,
    },
    {
      field: 'dsticketstatus',
      headerName: 'Estatus Ticket',
      flex: 1,
    },
    {
      field: 'dstipofalla',
      headerName: 'Tipo Falla',
      flex: 1,
    },
    {
      field: 'dsrequerimiento',
      headerName: 'Requerimiento',
      flex: 1,
    },
    {
      field: 'dstickettipo',
      headerName: 'Tipo Ticket',
      flex: 1,
    },
    {
      field: 'dscriticidad',
      headerName: 'Criticidad',
      flex: 1,
    },
  ];
  const [ticketSelected, setTicketSelected] = useState({ row: {} });
  const [openTicketModal, setOpenTicketModal] = useState(false);

  const handlerClose = () => setOpenTicketModal(false);

  const handleClick = (row) => {
    getTicketsDet({
      criticidadTicket: 0,
      tipoFalla: 0,
      ticketStatus: 0,
      tipoTicket: 0,
      tipoRequerimiento: 0,
      numReporteSoc: row.row.numreportesoc,
      numReporteBestel: '',
    })
      .then((response) => {
        console.log(response);
        setTicketSelected({ row: response[0] });
        setOpenTicketModal(true);
      })
      .catch((error) => {
        SweetAlertBasic('error', 'Algo salio mal', 'Vuelve a intentarlo más tarde');
      });
  };

  return (
    <>
      <Modal open={openModal} onClose={handleCloseModal} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
        <Box display="flex" justifyContent="center" alignItems="center" sx={modalStyle} flexDirection="column">
          <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-end', width: '100%' }}>
            <IconButton aria-label="close-ticket-modal-btn" size="medium" onClick={handleCloseModal}>
              <CloseIcon />
            </IconButton>
          </div>
          <DataGrid
            sx={{
              width: '100%',
              '& .MuiDataGrid-row:hover': {
                background: '#01A9DB',
                cursor: 'pointer',
              },
            }}
            getRowId={(row) => row.ticketId}
            loading={loading}
            rows={ticketsData}
            columns={columns}
            localeText={esES.components.MuiDataGrid.defaultProps.localeText}
            disableRowSelectionOnClick
            onRowClick={handleClick}
          />
        </Box>
      </Modal>
      <TicketModal openModal={openTicketModal} handlerClose={handlerClose} ticketSel={ticketSelected} />
    </>
  );
};

export default TicketsModal;
